import { Link } from '@tanstack/react-router';

import { useMessages } from '@/hooks/messages';

import { notFoundMessageDefinitions } from './messages';

export const NotFound = () => {
  const messages = useMessages(notFoundMessageDefinitions);

  return (
    <div className='m-5 flex flex-col items-center gap-5'>
      <p>{messages.resourceDoesNotExist()}</p>
      <Link to='/'>{messages.homePageButton()}</Link>
    </div>
  );
};
